import { TAppState } from '../../types/appState';

export const isMasterSelector = (state: TAppState) => {
  const { isAuthenticated, agentAccountType } = state.user;

  return isAuthenticated && agentAccountType === 'agency';
};
